import {
  SAVE_USER_FAILURE,
  SAVE_USER_SUCCESS,
  FETCH_USER_DATA_REQUEST,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
} from './types/UserActionTypes';

export function saveUserSuccessActionCreator() {
  return {
    type: SAVE_USER_SUCCESS,
  };
}

export function saveUserFailureActionCreator(error) {
  return {
    type: SAVE_USER_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchUserDataRequestActionCreator() {
  return {
    type: FETCH_USER_DATA_REQUEST,
  };
}

export function fetchUserDataSuccessActionCreator(userInfo) {
  return {
    type: FETCH_USER_DATA_SUCCESS,
    payload: {
      userInfo,
    },
  };
}

export function fetchUserDataFailureActionCreator(error) {
  return {
    type: FETCH_USER_DATA_FAILURE,
    payload: error,
    error: true,
  };
}
